import Particles from '@tsparticles/react';
import { memo, useMemo } from 'react';
import type { IOptions, RecursivePartial } from '@tsparticles/engine';

interface ParticlesWrapperProps {
    id: string;
    imgSrc: string;
}

const ParticlesWrapper = memo(({ id, imgSrc }: ParticlesWrapperProps) => {
    const particleOptions = useMemo(
        () => ({
            style: {
                width: '379px',
                height: '460px',
            },
            fullScreen: false,
            particles: {
                number: {
                    value: 80,
                    density: {
                        enable: true,
                        width: 800,
                    },
                },
                color: {
                    value: '#8346f96b',
                },
                shape: {
                    type: 'image',
                    options: {
                        image: [
                            {
                                src: imgSrc,
                                width: 100,
                                height: 100,
                            },
                        ],
                    },
                },
                opacity: {
                    value: { min: 0.1, max: 0.5 },
                    animation: {
                        enable: true,
                        speed: 0.2,
                        sync: false,
                    },
                },
                size: {
                    value: { min: 2, max: 6 },
                    animation: {
                        enable: true,
                        speed: 5,
                        sync: false,
                    },
                },
                move: {
                    enable: true,
                    speed: { min: 0.15, max: 0.5 },
                    direction: 'top',
                    straight: false,
                    outModes: {
                        default: 'out',
                    },
                    random: true,
                },
                zIndex: {
                    value: {
                        min: 0,
                        max: 50,
                    },
                },
            },
            background: {
                color: 'transparent',
            },
        }),
        [imgSrc]
    );

    return (
        <Particles
            id={id}
            className='size-full relative'
            options={particleOptions as RecursivePartial<IOptions>}
        />
    );
});

ParticlesWrapper.displayName = 'ParticlesWrapper';

export default ParticlesWrapper;